<template>
  <v-container fluid>
    <img alt="Vue logo" class="landing-image" src="../assets/CHARACTER-01.png" />

    <Search style="margin-top: -100px;" route-name="missings"></Search>

    <div class="text-left landing-text">
      <h1 class="primary--text display-3">ما هو مفقود؟</h1>
      <p>مفقود هو منصة إجتماعية للبلاغ عن المفقودات للمساعدة على إيجادها والتواصل مع أصحابها</p>
    </div>
  </v-container>
</template>

<script>
/* eslint-disable */
import HelloWorld from "@/components/HelloWorld.vue";
import Search from "@/components/missings/Search.vue";
export default {
  name: "home",
  components: {
    HelloWorld,
    Search
  }
};
</script>

<style  scoped>
.landing-image {
  margin-top: -22px;
  height: 500px;
  width: 100%;
  box-shadow: 0 0 30px 30px transparent inset;
  background: rgb(125, 185, 232); /* Old browsers */
  background: -moz-linear-gradient(
    top,
    rgba(125, 185, 232, 1) 1%,
    rgba(232, 211, 177, 1) 100%
  ); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    top,
    rgba(125, 185, 232, 1) 1%,
    rgba(232, 211, 177, 1) 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to bottom,
    rgba(125, 185, 232, 1) 1%,
    rgba(232, 211, 177, 1) 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#7db9e8', endColorstr='#e8d3b1',GradientType=0 ); /* IE6-9 */
}
.landing-text {
  padding: 15px;
  margin-top: -450px;
}
</style>
